import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfiguracaoNfComponent } from './configuracao-nf.component';

const routes: Routes = [
  {
    path: '',
    component: ConfiguracaoNfComponent,
    title: 'Configuração NF',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfiguracaoNfRoutingModule { }
